import { CreateCheckoutResponse, CreateInviteResponse, CreateTransactionResponse, GetGroupsResponse, GetInternalLinkResponse, GetMessagesResponse, GetOfferResponse, GetPublicLinkResponse } from "./api-types";

export type HttpMethod = 'get' | 'post' | 'put' | 'delete';

export interface ApiEndpoint<TInput, TOutput> {
  method: HttpMethod;
  path: string;
}
 const envPrefix ='prod';
console.log(`API CLIENT [${envPrefix}]`);

export const linkApiSchema = {
  createInvite: {
    method: 'post',
    path: `/${envPrefix}/link/invite/`,
  } satisfies ApiEndpoint<{ groupId: string }, CreateInviteResponse>,

  acceptInvite: {
    method: 'post',
    path: `/${envPrefix}/link/invite/accept/`,
  } satisfies ApiEndpoint<{ linkId: string }, void>,

  getInternalLink: {
    method: 'post',
    path: `/${envPrefix}/link/`,
  } satisfies ApiEndpoint<{ linkId: string }, GetInternalLinkResponse>,

  getPublicLink: {
    method: 'post',
    path: `/${envPrefix}/publiclink/`,
  } satisfies ApiEndpoint<{ linkId: string }, GetPublicLinkResponse>,
};

export const storeApiSchema = {
  //maybe we don't even need this one...
  getOffer: {
    method: 'post',
    path: `/${envPrefix}/store/offer/`,
  } satisfies ApiEndpoint<{ offerId: string }, GetOfferResponse>,

  createTransaction: {
    method: 'post',
    path: `/${envPrefix}/store/transaction/`,
  } satisfies ApiEndpoint<{ offerId: string, paymentReturnUrl:string, taxNumber?:string, paymentMethod?:string }, CreateTransactionResponse>,

  createCheckout: {
    method: 'post',
    path: `/${envPrefix}/store/checkout/`,
  } satisfies ApiEndpoint<{ offerId: string, linkId:string, baseUrl:string}, CreateCheckoutResponse>,

  confirmfaketransaction: {
    method: 'post',
    path: `/${envPrefix}/store/confirmfaketransaction/`,
  } satisfies ApiEndpoint<{ offerId: string }, {}>,

  confirmTransaction: {
    method: 'post',
    path: `/${envPrefix}/store/forceConfirmTransaction/`,
  } satisfies ApiEndpoint<{ transactionId: string }, {success:boolean}>,
  cancelCheckout: {
    method: 'post',
    path: `/${envPrefix}/store/forceCancelCheckout/`,
  } satisfies ApiEndpoint<{ transactionId: string }, {success:boolean}>,};

export const userApiSchema = {
  uploadAvatar: {
    method: 'post',
    path: `/${envPrefix}/user/avatar/`,
  } satisfies ApiEndpoint<void, CreateInviteResponse>,
  
  deleteAvatar: {
    method: 'delete',
    path: `/${envPrefix}/user/avatar/`,
  } satisfies ApiEndpoint<void, void>,
};


export const groupApiSchema = {
  getUserGroupsByProduct: {
    method: 'post',
    path: `/${envPrefix}/group/groups/`,
  } satisfies ApiEndpoint<{ productId: string }, GetGroupsResponse>,
  
  getMessages: {
    method: 'post',
    path: `/${envPrefix}/group/messages/`,
  } satisfies ApiEndpoint<{ groupId: string, chatId:string }, GetMessagesResponse>,

  sendMessage: {
    method: 'post',
    path: `/${envPrefix}/group/message/`,
  } satisfies ApiEndpoint<{ groupId: string, chatId:string, content:string }, void>,
};

export const apiSchema = {
  ...linkApiSchema,
  ...storeApiSchema,
  ...userApiSchema,
  ...groupApiSchema,
} as const;

export type ApiSchema = typeof apiSchema;
export type ApiName = keyof ApiSchema;

export type ApiInput<K extends ApiName> =
  ApiSchema[K] extends ApiEndpoint<infer I, any> ? I : never;

export type ApiOutput<K extends ApiName> =
  ApiSchema[K] extends ApiEndpoint<any, infer O> ? O : never;
